
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqbuNdR5bl5n0tJ3f5wH_45wfJsT4_45FVhf36nNmRHZZmKmkMeta } from "/codebuild/output/src1852518591/src/pages/faq.vue?macro=true";
import { default as indexuzoJFqF9v8fsdBjOnEx4GHB1nn1vFMTq0LgJddKHgSYMeta } from "/codebuild/output/src1852518591/src/pages/index.vue?macro=true";
import { default as loginHv2oZ_45A70eZdr4A4JMYqb6i3CnUq81Kd74pqZGAb_iYMeta } from "/codebuild/output/src1852518591/src/pages/login.vue?macro=true";
import { default as searchUzyxY8zoYnUZIMtHr3iznu1XjIf2woIQN7lLqFcWB2MMeta } from "/codebuild/output/src1852518591/src/pages/search.vue?macro=true";
import { default as inquiryUmTaY2bwrxIsTD2hXDFaXL2xROUdT_vn_GYO84IJvOoMeta } from "/codebuild/output/src1852518591/src/pages/inquiry.vue?macro=true";
import { default as listl0WfHRLFYhosl657yTUMlz6tDgbmDkuWL68pHTwuVrMMeta } from "/codebuild/output/src1852518591/src/pages/mail/list.vue?macro=true";
import { default as likemlxQJw4H8Twg3LbHQmr80UwEGVADxQwrSHVPxub9QBkMeta } from "/codebuild/output/src1852518591/src/pages/user/like.vue?macro=true";
import { default as guidevtGvdCVzraUXBx6F_45uFg5zAVqdC3WyST843CPPPjiCAMeta } from "/codebuild/output/src1852518591/src/pages/help/guide.vue?macro=true";
import { default as indexEDWP9jJ_aiQjz6dvWcXFLSP0xyCwjE_EiWIhXVRAdtcMeta } from "/codebuild/output/src1852518591/src/pages/help/index.vue?macro=true";
import { default as applicationO7hEBxScQ0MQmm56tictIJhHkhec3bU5NqMaiRa6CVsMeta } from "/codebuild/output/src1852518591/src/pages/application.vue?macro=true";
import { default as createw6l4MnB2suCBU97v6fVSHX44kQ9NnCoooEw6u301508Meta } from "/codebuild/output/src1852518591/src/pages/mail/create.vue?macro=true";
import { default as pr_45supplier23PT_ooKrP_45QZxmg1Az3AaqmkZjFzae6XLdxozCjjKIMeta } from "/codebuild/output/src1852518591/src/pages/pr-supplier.vue?macro=true";
import { default as bookQauZjiiW8tbKJtnZ00HLETdxp4xR0b6gHlXsnO1eUWgMeta } from "/codebuild/output/src1852518591/src/pages/report/book.vue?macro=true";
import { default as colorLIcLyqMnpQZMaCcqeB47AQWslXpw98e7ZQHDluv94BkMeta } from "/codebuild/output/src1852518591/src/pages/yarns/color.vue?macro=true";
import { default as indexy81Ez_BgGxIjQC6hKbKqHTuDcpb50XA19vrh2Gzp3IMMeta } from "/codebuild/output/src1852518591/src/pages/yarns/index.vue?macro=true";
import { default as indexjYXejguPLgYrCJunplpUZtsWlUZkpnBgwPAi7DL6fD0Meta } from "/codebuild/output/src1852518591/src/pages/admins/index.vue?macro=true";
import { default as shima_T8jxDx8OWj7gUpxBA_eZ5X3hgEByaURbooVO6m6rToMeta } from "/codebuild/output/src1852518591/src/pages/admins/shima.vue?macro=true";
import { default as terms_of_useWPALMmEbvOZp2FPbzdOEdWpHescb4OqwTXG76oQAlwgMeta } from "/codebuild/output/src1852518591/src/pages/terms_of_use.vue?macro=true";
import { default as cookie_policylGNkmZJLmjhm07z0XE9GF5K9diyDNiyse3QR3Hm2ZZoMeta } from "/codebuild/output/src1852518591/src/pages/cookie_policy.vue?macro=true";
import { default as trainingghoPafMGLh4UbPU6w_0x7AJF0Uh1TzCYtcxyhItb1oIMeta } from "/codebuild/output/src1852518591/src/pages/help/training.vue?macro=true";
import { default as color7SfBEkNnHHwsCv_45i9aRRQKVIARtxHpjaAeVXJxmG1yAMeta } from "/codebuild/output/src1852518591/src/pages/myyarns/color.vue?macro=true";
import { default as indexSRmIM9A0Z38FBjyiCjWFDnP06pP545EwYx1RrlLk5osMeta } from "/codebuild/output/src1852518591/src/pages/myyarns/index.vue?macro=true";
import { default as _91id_93wfdX2YnN8ygUmmLbXgjbdyqhEH487OG3GTCrCEnZVGYMeta } from "/codebuild/output/src1852518591/src/pages/supplier/[id].vue?macro=true";
import { default as downloadLBadTPzOUkuVMDUhQ_sc_45oICA9bZ6RDzRiXP474rupgMeta } from "/codebuild/output/src1852518591/src/pages/user/download.vue?macro=true";
import { default as apexlogrkAyWb7AeXhvZEQ86aXtMONCindxHjvzNhfzSHZ7EccMeta } from "/codebuild/output/src1852518591/src/pages/admins/apexlog.vue?macro=true";
import { default as createzfDStnJkpEr2HTy7Fa9tPQVgiAWOdMqBm9jDyuXav4YMeta } from "/codebuild/output/src1852518591/src/pages/company/create.vue?macro=true";
import { default as _91id_93KrkLrHO_45tBI0AwS3sqursBaYB0FTp3PdbG7kBr6fADQMeta } from "/codebuild/output/src1852518591/src/pages/mail/edit/[id].vue?macro=true";
import { default as createmM5RGYa6jpXyVYHyHfklyeehbGoWr_45kL4vJyRmeutAEMeta } from "/codebuild/output/src1852518591/src/pages/myyarns/create.vue?macro=true";
import { default as privacy_policysXN3RV30sObSMeVUjMgVk2UTqXwJNiJflEdtcHpMecwMeta } from "/codebuild/output/src1852518591/src/pages/privacy_policy.vue?macro=true";
import { default as indexplOAYssvTlocgi_xg2b6zHlpgd_DUUY9SH21fD4fMP4Meta } from "/codebuild/output/src1852518591/src/pages/supplier/index.vue?macro=true";
import { default as customerme9GIbNFufFNybjU204efzMsVc_45epFg_45aRtEPg2q8jAMeta } from "/codebuild/output/src1852518591/src/pages/admins/customer.vue?macro=true";
import { default as categorySrYMj6BA4NiUsuhf3ZsN4ztDrw5NWRahXSMb6_D3OpQMeta } from "/codebuild/output/src1852518591/src/pages/report/category.vue?macro=true";
import { default as indexo4CTaELpz1KAcHWQLqH609N0LJ5iZSFdzVvcb2aTAMQMeta } from "/codebuild/output/src1852518591/src/pages/yarn/[id]/index.vue?macro=true";
import { default as bookCqLi_brKJH_45LNP0huqJu2nMqK1aiC_45h_451yRrmgF2XIAMeta } from "/codebuild/output/src1852518591/src/pages/report/[id]/book.vue?macro=true";
import { default as indexX_45HnJPNwQKF_mFyPf_45O27yH1EisZBTdMqRb_45ziNz8oMMeta } from "/codebuild/output/src1852518591/src/pages/admins/code/index.vue?macro=true";
import { default as index2levcxQaGHcRBgXvLkETNAK0oLXGyl_9aFspLYf0GmwMeta } from "/codebuild/output/src1852518591/src/pages/admins/mail/index.vue?macro=true";
import { default as editvLre8hAG8UZUJoEdIgzfwWxxQwSj1QWhsYAkdXDa8lsMeta } from "/codebuild/output/src1852518591/src/pages/myyarns/[id]/edit.vue?macro=true";
import { default as mailyLQPrCgmqveDVydT2FUa5A_45uCcGWAL22U5WLoGXtFFcMeta } from "/codebuild/output/src1852518591/src/pages/user/profile/mail.vue?macro=true";
import { default as commonEk2trBo33rN_45dKwnFHkdVHLkOxuJb7uMwNyLbaSMrMcMeta } from "/codebuild/output/src1852518591/src/pages/admins/code/common.vue?macro=true";
import { default as markettrendHaATs63QuAUjjl26qscQ0mZXQDC7UXMr6a2GNgRkHlsMeta } from "/codebuild/output/src1852518591/src/pages/report/markettrend.vue?macro=true";
import { default as downloadblock53k0V_A4r9Tq4QGc6AfBcX_40Nbovdzn5okcyK3yhQYMeta } from "/codebuild/output/src1852518591/src/pages/user/downloadblock.vue?macro=true";
import { default as group3IhkqJ4EpM30TmRaU9YF0s0WVh0p4gzOTOQeuXCWX3cMeta } from "/codebuild/output/src1852518591/src/pages/user/profile/group.vue?macro=true";
import { default as indexX0TCGLKHtTNRWVG93B7mdrmCMa7_45EJ5sSCdP2utgC6UMeta } from "/codebuild/output/src1852518591/src/pages/user/profile/index.vue?macro=true";
import { default as terms7VnqglB_4583dQKvAN1OZAk4dr0bkpmo_4WuXozlxJGY4Meta } from "/codebuild/output/src1852518591/src/pages/user/profile/terms.vue?macro=true";
import { default as countrywCPoE_tOEFrzIlMgUv4DScjJdG75QlRuDQ_45HbJJrnKAMeta } from "/codebuild/output/src1852518591/src/pages/admins/code/country.vue?macro=true";
import { default as helpBadt_454wYaZDoqH7jZfvFqJxiQj3yqjflNmHJwk0wufEMeta } from "/codebuild/output/src1852518591/src/pages/admins/profile/help.vue?macro=true";
import { default as templaterzNWgzbhzEdO164m8_45lHWaGqOuAz_VWnRQ4aNrp3aLMMeta } from "/codebuild/output/src1852518591/src/pages/admins/mail/template.vue?macro=true";
import { default as indexVxllgo7aC3WaL3vypfMtFQZpn6g9RlQ91TaaYGn1MGUMeta } from "/codebuild/output/src1852518591/src/pages/admins/profile/index.vue?macro=true";
import { default as termsA7aEee5W7pHybx0nTvN2zW6rRnbtSUW93Mv4Xg_45iRewMeta } from "/codebuild/output/src1852518591/src/pages/admins/profile/terms.vue?macro=true";
import { default as _91mailId_93rdPsXAFbT_OV6HC2uc7Zkh8SYUD1RlcQe9AbZ6ymdV4Meta } from "/codebuild/output/src1852518591/src/pages/mail/report/[mailId].vue?macro=true";
import { default as previewNZ00ONBUf2PCzYY0CTEZo5QDxlCweZVZR13ujBsYAZ8Meta } from "/codebuild/output/src1852518591/src/pages/myyarns/[id]/preview.vue?macro=true";
import { default as company876yLKHbfi2tMiKFMkttBQxVvdCUk4QAktMAZPz2tUsMeta } from "/codebuild/output/src1852518591/src/pages/user/profile/company.vue?macro=true";
import { default as continentHK8hPAXVaH64uJ5rm0yzbKDA6M2hYyMyXYlF2iNJeqIMeta } from "/codebuild/output/src1852518591/src/pages/admins/code/continent.vue?macro=true";
import { default as indexR9jYOaFEsn0xIoeGD3PQmGlYe7Jl9qQjIbqFfIICTvoMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/index.vue?macro=true";
import { default as indexcXuyEq__jYBFfqpAuafkxr1U0XTlBIm5jyGOHBAWAKQMeta } from "/codebuild/output/src1852518591/src/pages/admins/pr-supplier/index.vue?macro=true";
import { default as index1_daBgzPe8fToNohsFD8qw_8sjTUlrkm5hfEL2UX1kAMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/index.vue?macro=true";
import { default as suppliermanagersbb1AGeCQ2nT6LJj7zfTYVsKsJaZqB74Jcc49_45v_45i5gMeta } from "/codebuild/output/src1852518591/src/pages/admins/mail/suppliermanager.vue?macro=true";
import { default as createyQSh87pcT_j5aZY_4eNr_sycoNzmPWSgDLpAnc4wM5sMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/create.vue?macro=true";
import { default as reportgKIJyYSB1xpFeZY6LJ4lN8HTvuTki6r4ZfAlWCJoaGMMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/report.vue?macro=true";
import { default as indextAFlx45JlkO1BJtCBj_45uX68MD4DxDLiEl_45Ss0rGhofgMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/index.vue?macro=true";
import { default as downloadblockL74pIl3KIi5U4RIoZ710qzkDMPTPDxUWMWeWOwbJNnEMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/downloadblock.vue?macro=true";
import { default as bookW7hCRJ77JhAfseaUeBBllIZRni37fnzcToXkhmTCfcIMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/book.vue?macro=true";
import { default as editZj02ysW3x_u6xyq6jUtYFxORb0oaXec_kaR73D7KRnAMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/edit.vue?macro=true";
import { default as previewCSKg_EYi_45GuCOjw1IWH_45ZC3y0OdZZoMXD8j24nG0rs0Meta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/preview.vue?macro=true";
import { default as _91mailId_938GPq6x9r7_45LhlTNbskUOrk_qJAqmp_45lLMrMoMEosYXsMeta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/report/[mailId].vue?macro=true";
import { default as indexWN4tIFqL0jYXwjqFccnm7axAgKayNaIAe9SS5fI7J48Meta } from "/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/edit/[subId]/index.vue?macro=true";
export default [
  {
    name: "faq___en",
    path: "/faq",
    component: () => import("/codebuild/output/src1852518591/src/pages/faq.vue")
  },
  {
    name: "faq___zh",
    path: "/zh/faq",
    component: () => import("/codebuild/output/src1852518591/src/pages/faq.vue")
  },
  {
    name: "faq___ja",
    path: "/ja/faq",
    component: () => import("/codebuild/output/src1852518591/src/pages/faq.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: {"middleware":"home"},
    component: () => import("/codebuild/output/src1852518591/src/pages/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: {"middleware":"home"},
    component: () => import("/codebuild/output/src1852518591/src/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: {"middleware":"home"},
    component: () => import("/codebuild/output/src1852518591/src/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: loginHv2oZ_45A70eZdr4A4JMYqb6i3CnUq81Kd74pqZGAb_iYMeta || {},
    component: () => import("/codebuild/output/src1852518591/src/pages/login.vue")
  },
  {
    name: "login___zh",
    path: "/zh/login",
    meta: loginHv2oZ_45A70eZdr4A4JMYqb6i3CnUq81Kd74pqZGAb_iYMeta || {},
    component: () => import("/codebuild/output/src1852518591/src/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: loginHv2oZ_45A70eZdr4A4JMYqb6i3CnUq81Kd74pqZGAb_iYMeta || {},
    component: () => import("/codebuild/output/src1852518591/src/pages/login.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/search.vue")
  },
  {
    name: "search___zh",
    path: "/zh/search",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/search.vue")
  },
  {
    name: "search___ja",
    path: "/ja/search",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/search.vue")
  },
  {
    name: "inquiry___en",
    path: "/inquiry",
    component: () => import("/codebuild/output/src1852518591/src/pages/inquiry.vue")
  },
  {
    name: "inquiry___zh",
    path: "/zh/inquiry",
    component: () => import("/codebuild/output/src1852518591/src/pages/inquiry.vue")
  },
  {
    name: "inquiry___ja",
    path: "/ja/inquiry",
    component: () => import("/codebuild/output/src1852518591/src/pages/inquiry.vue")
  },
  {
    name: "mail-list___en",
    path: "/mail/list",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/list.vue")
  },
  {
    name: "mail-list___zh",
    path: "/zh/mail/list",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/list.vue")
  },
  {
    name: "mail-list___ja",
    path: "/ja/mail/list",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/list.vue")
  },
  {
    name: "user-like___en",
    path: "/user/like",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/like.vue")
  },
  {
    name: "user-like___zh",
    path: "/zh/user/like",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/like.vue")
  },
  {
    name: "user-like___ja",
    path: "/ja/user/like",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/like.vue")
  },
  {
    name: "help-guide___en",
    path: "/help/guide",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/guide.vue")
  },
  {
    name: "help-guide___zh",
    path: "/zh/help/guide",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/guide.vue")
  },
  {
    name: "help-guide___ja",
    path: "/ja/help/guide",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/guide.vue")
  },
  {
    name: "help___en",
    path: "/help",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/index.vue")
  },
  {
    name: "help___zh",
    path: "/zh/help",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/index.vue")
  },
  {
    name: "help___ja",
    path: "/ja/help",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/index.vue")
  },
  {
    name: "application___en",
    path: "/application",
    component: () => import("/codebuild/output/src1852518591/src/pages/application.vue")
  },
  {
    name: "application___zh",
    path: "/zh/application",
    component: () => import("/codebuild/output/src1852518591/src/pages/application.vue")
  },
  {
    name: "application___ja",
    path: "/ja/application",
    component: () => import("/codebuild/output/src1852518591/src/pages/application.vue")
  },
  {
    name: "mail-create___en",
    path: "/mail/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/create.vue")
  },
  {
    name: "mail-create___zh",
    path: "/zh/mail/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/create.vue")
  },
  {
    name: "mail-create___ja",
    path: "/ja/mail/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/create.vue")
  },
  {
    name: "pr-supplier___en",
    path: "/pr-supplier",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/pr-supplier.vue")
  },
  {
    name: "pr-supplier___zh",
    path: "/zh/pr-supplier",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/pr-supplier.vue")
  },
  {
    name: "pr-supplier___ja",
    path: "/ja/pr-supplier",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/pr-supplier.vue")
  },
  {
    name: "report-book___en",
    path: "/report/book",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/book.vue")
  },
  {
    name: "report-book___zh",
    path: "/zh/report/book",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/book.vue")
  },
  {
    name: "report-book___ja",
    path: "/ja/report/book",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/book.vue")
  },
  {
    name: "yarns-color___en",
    path: "/yarns/color",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarns/color.vue")
  },
  {
    name: "yarns-color___zh",
    path: "/zh/yarns/color",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarns/color.vue")
  },
  {
    name: "yarns-color___ja",
    path: "/ja/yarns/color",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarns/color.vue")
  },
  {
    name: "yarns___en",
    path: "/yarns",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarns/index.vue")
  },
  {
    name: "yarns___zh",
    path: "/zh/yarns",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarns/index.vue")
  },
  {
    name: "yarns___ja",
    path: "/ja/yarns",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarns/index.vue")
  },
  {
    name: "admins___en",
    path: "/admins",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/index.vue")
  },
  {
    name: "admins___zh",
    path: "/zh/admins",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/index.vue")
  },
  {
    name: "admins___ja",
    path: "/ja/admins",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/index.vue")
  },
  {
    name: "admins-shima___en",
    path: "/admins/shima",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/shima.vue")
  },
  {
    name: "admins-shima___zh",
    path: "/zh/admins/shima",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/shima.vue")
  },
  {
    name: "admins-shima___ja",
    path: "/ja/admins/shima",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/shima.vue")
  },
  {
    name: "terms_of_use___en",
    path: "/terms_of_use",
    component: () => import("/codebuild/output/src1852518591/src/pages/terms_of_use.vue")
  },
  {
    name: "terms_of_use___zh",
    path: "/zh/terms_of_use",
    component: () => import("/codebuild/output/src1852518591/src/pages/terms_of_use.vue")
  },
  {
    name: "terms_of_use___ja",
    path: "/ja/terms_of_use",
    component: () => import("/codebuild/output/src1852518591/src/pages/terms_of_use.vue")
  },
  {
    name: "cookie_policy___en",
    path: "/cookie_policy",
    component: () => import("/codebuild/output/src1852518591/src/pages/cookie_policy.vue")
  },
  {
    name: "cookie_policy___zh",
    path: "/zh/cookie_policy",
    component: () => import("/codebuild/output/src1852518591/src/pages/cookie_policy.vue")
  },
  {
    name: "cookie_policy___ja",
    path: "/ja/cookie_policy",
    component: () => import("/codebuild/output/src1852518591/src/pages/cookie_policy.vue")
  },
  {
    name: "help-training___en",
    path: "/help/training",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/training.vue")
  },
  {
    name: "help-training___zh",
    path: "/zh/help/training",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/training.vue")
  },
  {
    name: "help-training___ja",
    path: "/ja/help/training",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/help/training.vue")
  },
  {
    name: "myyarns-color___en",
    path: "/myyarns/color",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/color.vue")
  },
  {
    name: "myyarns-color___zh",
    path: "/zh/myyarns/color",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/color.vue")
  },
  {
    name: "myyarns-color___ja",
    path: "/ja/myyarns/color",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/color.vue")
  },
  {
    name: "myyarns___en",
    path: "/myyarns",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/index.vue")
  },
  {
    name: "myyarns___zh",
    path: "/zh/myyarns",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/index.vue")
  },
  {
    name: "myyarns___ja",
    path: "/ja/myyarns",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/index.vue")
  },
  {
    name: "supplier-id___en",
    path: "/supplier/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___zh",
    path: "/zh/supplier/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___ja",
    path: "/ja/supplier/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/supplier/[id].vue")
  },
  {
    name: "user-download___en",
    path: "/user/download",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/download.vue")
  },
  {
    name: "user-download___zh",
    path: "/zh/user/download",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/download.vue")
  },
  {
    name: "user-download___ja",
    path: "/ja/user/download",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/download.vue")
  },
  {
    name: "admins-apexlog___en",
    path: "/admins/apexlog",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/apexlog.vue")
  },
  {
    name: "admins-apexlog___zh",
    path: "/zh/admins/apexlog",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/apexlog.vue")
  },
  {
    name: "admins-apexlog___ja",
    path: "/ja/admins/apexlog",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/apexlog.vue")
  },
  {
    name: "company-create___en",
    path: "/company/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/company/create.vue")
  },
  {
    name: "company-create___zh",
    path: "/zh/company/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/company/create.vue")
  },
  {
    name: "company-create___ja",
    path: "/ja/company/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/company/create.vue")
  },
  {
    name: "mail-edit-id___en",
    path: "/mail/edit/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/edit/[id].vue")
  },
  {
    name: "mail-edit-id___zh",
    path: "/zh/mail/edit/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/edit/[id].vue")
  },
  {
    name: "mail-edit-id___ja",
    path: "/ja/mail/edit/:id()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/edit/[id].vue")
  },
  {
    name: "myyarns-create___en",
    path: "/myyarns/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/create.vue")
  },
  {
    name: "myyarns-create___zh",
    path: "/zh/myyarns/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/create.vue")
  },
  {
    name: "myyarns-create___ja",
    path: "/ja/myyarns/create",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/create.vue")
  },
  {
    name: "privacy_policy___en",
    path: "/privacy_policy",
    component: () => import("/codebuild/output/src1852518591/src/pages/privacy_policy.vue")
  },
  {
    name: "privacy_policy___zh",
    path: "/zh/privacy_policy",
    component: () => import("/codebuild/output/src1852518591/src/pages/privacy_policy.vue")
  },
  {
    name: "privacy_policy___ja",
    path: "/ja/privacy_policy",
    component: () => import("/codebuild/output/src1852518591/src/pages/privacy_policy.vue")
  },
  {
    name: "supplier___en",
    path: "/supplier",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/supplier/index.vue")
  },
  {
    name: "supplier___zh",
    path: "/zh/supplier",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/supplier/index.vue")
  },
  {
    name: "supplier___ja",
    path: "/ja/supplier",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/supplier/index.vue")
  },
  {
    name: "admins-customer___en",
    path: "/admins/customer",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/customer.vue")
  },
  {
    name: "admins-customer___zh",
    path: "/zh/admins/customer",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/customer.vue")
  },
  {
    name: "admins-customer___ja",
    path: "/ja/admins/customer",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/customer.vue")
  },
  {
    name: "report-category___en",
    path: "/report/category",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/category.vue")
  },
  {
    name: "report-category___zh",
    path: "/zh/report/category",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/category.vue")
  },
  {
    name: "report-category___ja",
    path: "/ja/report/category",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/category.vue")
  },
  {
    name: "yarn-id___en",
    path: "/yarn/:id()",
    meta: {"middleware":["authenticated","yarn"]},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarn/[id]/index.vue")
  },
  {
    name: "yarn-id___zh",
    path: "/zh/yarn/:id()",
    meta: {"middleware":["authenticated","yarn"]},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarn/[id]/index.vue")
  },
  {
    name: "yarn-id___ja",
    path: "/ja/yarn/:id()",
    meta: {"middleware":["authenticated","yarn"]},
    component: () => import("/codebuild/output/src1852518591/src/pages/yarn/[id]/index.vue")
  },
  {
    name: "report-id-book___en",
    path: "/report/:id()/book",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/[id]/book.vue")
  },
  {
    name: "report-id-book___zh",
    path: "/zh/report/:id()/book",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/[id]/book.vue")
  },
  {
    name: "report-id-book___ja",
    path: "/ja/report/:id()/book",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/[id]/book.vue")
  },
  {
    name: "admins-code___en",
    path: "/admins/code",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/index.vue")
  },
  {
    name: "admins-code___zh",
    path: "/zh/admins/code",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/index.vue")
  },
  {
    name: "admins-code___ja",
    path: "/ja/admins/code",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/index.vue")
  },
  {
    name: "admins-mail___en",
    path: "/admins/mail",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/index.vue")
  },
  {
    name: "admins-mail___zh",
    path: "/zh/admins/mail",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/index.vue")
  },
  {
    name: "admins-mail___ja",
    path: "/ja/admins/mail",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/index.vue")
  },
  {
    name: "myyarns-id-edit___en",
    path: "/myyarns/:id()/edit",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/[id]/edit.vue")
  },
  {
    name: "myyarns-id-edit___zh",
    path: "/zh/myyarns/:id()/edit",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/[id]/edit.vue")
  },
  {
    name: "myyarns-id-edit___ja",
    path: "/ja/myyarns/:id()/edit",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/[id]/edit.vue")
  },
  {
    name: "user-profile-mail___en",
    path: "/user/profile/mail",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/mail.vue")
  },
  {
    name: "user-profile-mail___zh",
    path: "/zh/user/profile/mail",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/mail.vue")
  },
  {
    name: "user-profile-mail___ja",
    path: "/ja/user/profile/mail",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/mail.vue")
  },
  {
    name: "admins-code-common___en",
    path: "/admins/code/common",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/common.vue")
  },
  {
    name: "admins-code-common___zh",
    path: "/zh/admins/code/common",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/common.vue")
  },
  {
    name: "admins-code-common___ja",
    path: "/ja/admins/code/common",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/common.vue")
  },
  {
    name: "report-markettrend___en",
    path: "/report/markettrend",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/markettrend.vue")
  },
  {
    name: "report-markettrend___zh",
    path: "/zh/report/markettrend",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/markettrend.vue")
  },
  {
    name: "report-markettrend___ja",
    path: "/ja/report/markettrend",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/report/markettrend.vue")
  },
  {
    name: "user-downloadblock___en",
    path: "/user/downloadblock",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/downloadblock.vue")
  },
  {
    name: "user-downloadblock___zh",
    path: "/zh/user/downloadblock",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/downloadblock.vue")
  },
  {
    name: "user-downloadblock___ja",
    path: "/ja/user/downloadblock",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/downloadblock.vue")
  },
  {
    name: "user-profile-group___en",
    path: "/user/profile/group",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/group.vue")
  },
  {
    name: "user-profile-group___zh",
    path: "/zh/user/profile/group",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/group.vue")
  },
  {
    name: "user-profile-group___ja",
    path: "/ja/user/profile/group",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/group.vue")
  },
  {
    name: "user-profile___en",
    path: "/user/profile",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___zh",
    path: "/zh/user/profile",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile___ja",
    path: "/ja/user/profile",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/index.vue")
  },
  {
    name: "user-profile-terms___en",
    path: "/user/profile/terms",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/terms.vue")
  },
  {
    name: "user-profile-terms___zh",
    path: "/zh/user/profile/terms",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/terms.vue")
  },
  {
    name: "user-profile-terms___ja",
    path: "/ja/user/profile/terms",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/terms.vue")
  },
  {
    name: "admins-code-country___en",
    path: "/admins/code/country",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/country.vue")
  },
  {
    name: "admins-code-country___zh",
    path: "/zh/admins/code/country",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/country.vue")
  },
  {
    name: "admins-code-country___ja",
    path: "/ja/admins/code/country",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/country.vue")
  },
  {
    name: "admins-profile-help___en",
    path: "/admins/profile/help",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/help.vue")
  },
  {
    name: "admins-profile-help___zh",
    path: "/zh/admins/profile/help",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/help.vue")
  },
  {
    name: "admins-profile-help___ja",
    path: "/ja/admins/profile/help",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/help.vue")
  },
  {
    name: "admins-mail-template___en",
    path: "/admins/mail/template",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/template.vue")
  },
  {
    name: "admins-mail-template___zh",
    path: "/zh/admins/mail/template",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/template.vue")
  },
  {
    name: "admins-mail-template___ja",
    path: "/ja/admins/mail/template",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/template.vue")
  },
  {
    name: "admins-profile___en",
    path: "/admins/profile",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/index.vue")
  },
  {
    name: "admins-profile___zh",
    path: "/zh/admins/profile",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/index.vue")
  },
  {
    name: "admins-profile___ja",
    path: "/ja/admins/profile",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/index.vue")
  },
  {
    name: "admins-profile-terms___en",
    path: "/admins/profile/terms",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/terms.vue")
  },
  {
    name: "admins-profile-terms___zh",
    path: "/zh/admins/profile/terms",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/terms.vue")
  },
  {
    name: "admins-profile-terms___ja",
    path: "/ja/admins/profile/terms",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/profile/terms.vue")
  },
  {
    name: "mail-report-mailId___en",
    path: "/mail/report/:mailId()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/report/[mailId].vue")
  },
  {
    name: "mail-report-mailId___zh",
    path: "/zh/mail/report/:mailId()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/report/[mailId].vue")
  },
  {
    name: "mail-report-mailId___ja",
    path: "/ja/mail/report/:mailId()",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/mail/report/[mailId].vue")
  },
  {
    name: "myyarns-id-preview___en",
    path: "/myyarns/:id()/preview",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/[id]/preview.vue")
  },
  {
    name: "myyarns-id-preview___zh",
    path: "/zh/myyarns/:id()/preview",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/[id]/preview.vue")
  },
  {
    name: "myyarns-id-preview___ja",
    path: "/ja/myyarns/:id()/preview",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/myyarns/[id]/preview.vue")
  },
  {
    name: "user-profile-company___en",
    path: "/user/profile/company",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/company.vue")
  },
  {
    name: "user-profile-company___zh",
    path: "/zh/user/profile/company",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/company.vue")
  },
  {
    name: "user-profile-company___ja",
    path: "/ja/user/profile/company",
    meta: {"middleware":"authenticated"},
    component: () => import("/codebuild/output/src1852518591/src/pages/user/profile/company.vue")
  },
  {
    name: "admins-code-continent___en",
    path: "/admins/code/continent",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/continent.vue")
  },
  {
    name: "admins-code-continent___zh",
    path: "/zh/admins/code/continent",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/continent.vue")
  },
  {
    name: "admins-code-continent___ja",
    path: "/ja/admins/code/continent",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/code/continent.vue")
  },
  {
    name: "admins-supplier___en",
    path: "/admins/supplier",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/index.vue")
  },
  {
    name: "admins-supplier___zh",
    path: "/zh/admins/supplier",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/index.vue")
  },
  {
    name: "admins-supplier___ja",
    path: "/ja/admins/supplier",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/index.vue")
  },
  {
    name: "admins-pr-supplier___en",
    path: "/admins/pr-supplier",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/pr-supplier/index.vue")
  },
  {
    name: "admins-pr-supplier___zh",
    path: "/zh/admins/pr-supplier",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/pr-supplier/index.vue")
  },
  {
    name: "admins-pr-supplier___ja",
    path: "/ja/admins/pr-supplier",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/pr-supplier/index.vue")
  },
  {
    name: "admins-supplier-id___en",
    path: "/admins/supplier/:id()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/index.vue")
  },
  {
    name: "admins-supplier-id___zh",
    path: "/zh/admins/supplier/:id()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/index.vue")
  },
  {
    name: "admins-supplier-id___ja",
    path: "/ja/admins/supplier/:id()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/index.vue")
  },
  {
    name: "admins-mail-suppliermanager___en",
    path: "/admins/mail/suppliermanager",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/suppliermanager.vue")
  },
  {
    name: "admins-mail-suppliermanager___zh",
    path: "/zh/admins/mail/suppliermanager",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/suppliermanager.vue")
  },
  {
    name: "admins-mail-suppliermanager___ja",
    path: "/ja/admins/mail/suppliermanager",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/mail/suppliermanager.vue")
  },
  {
    name: "admins-supplier-id-create___en",
    path: "/admins/supplier/:id()/create",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/create.vue")
  },
  {
    name: "admins-supplier-id-create___zh",
    path: "/zh/admins/supplier/:id()/create",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/create.vue")
  },
  {
    name: "admins-supplier-id-create___ja",
    path: "/ja/admins/supplier/:id()/create",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/create.vue")
  },
  {
    name: "admins-supplier-id-report___en",
    path: "/admins/supplier/:id()/report",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/report.vue")
  },
  {
    name: "admins-supplier-id-report___zh",
    path: "/zh/admins/supplier/:id()/report",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/report.vue")
  },
  {
    name: "admins-supplier-id-report___ja",
    path: "/ja/admins/supplier/:id()/report",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/report.vue")
  },
  {
    name: "admins-supplier-id-mail___en",
    path: "/admins/supplier/:id()/mail",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/index.vue")
  },
  {
    name: "admins-supplier-id-mail___zh",
    path: "/zh/admins/supplier/:id()/mail",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/index.vue")
  },
  {
    name: "admins-supplier-id-mail___ja",
    path: "/ja/admins/supplier/:id()/mail",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/index.vue")
  },
  {
    name: "admins-supplier-id-downloadblock___en",
    path: "/admins/supplier/:id()/downloadblock",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/downloadblock.vue")
  },
  {
    name: "admins-supplier-id-downloadblock___zh",
    path: "/zh/admins/supplier/:id()/downloadblock",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/downloadblock.vue")
  },
  {
    name: "admins-supplier-id-downloadblock___ja",
    path: "/ja/admins/supplier/:id()/downloadblock",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/downloadblock.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-book___en",
    path: "/admins/supplier/:id()/:yarnlogId()/book",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/book.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-book___zh",
    path: "/zh/admins/supplier/:id()/:yarnlogId()/book",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/book.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-book___ja",
    path: "/ja/admins/supplier/:id()/:yarnlogId()/book",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/book.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-edit___en",
    path: "/admins/supplier/:id()/:yarnlogId()/edit",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/edit.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-edit___zh",
    path: "/zh/admins/supplier/:id()/:yarnlogId()/edit",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/edit.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-edit___ja",
    path: "/ja/admins/supplier/:id()/:yarnlogId()/edit",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/edit.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-preview___en",
    path: "/admins/supplier/:id()/:yarnlogId()/preview",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/preview.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-preview___zh",
    path: "/zh/admins/supplier/:id()/:yarnlogId()/preview",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/preview.vue")
  },
  {
    name: "admins-supplier-id-yarnlogId-preview___ja",
    path: "/ja/admins/supplier/:id()/:yarnlogId()/preview",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/[yarnlogId]/preview.vue")
  },
  {
    name: "admins-supplier-id-mail-report-mailId___en",
    path: "/admins/supplier/:id()/mail/report/:mailId()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/report/[mailId].vue")
  },
  {
    name: "admins-supplier-id-mail-report-mailId___zh",
    path: "/zh/admins/supplier/:id()/mail/report/:mailId()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/report/[mailId].vue")
  },
  {
    name: "admins-supplier-id-mail-report-mailId___ja",
    path: "/ja/admins/supplier/:id()/mail/report/:mailId()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/report/[mailId].vue")
  },
  {
    name: "admins-supplier-id-mail-edit-subId___en",
    path: "/admins/supplier/:id()/mail/edit/:subId()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/edit/[subId]/index.vue")
  },
  {
    name: "admins-supplier-id-mail-edit-subId___zh",
    path: "/zh/admins/supplier/:id()/mail/edit/:subId()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/edit/[subId]/index.vue")
  },
  {
    name: "admins-supplier-id-mail-edit-subId___ja",
    path: "/ja/admins/supplier/:id()/mail/edit/:subId()",
    meta: {"middleware":"admin"},
    component: () => import("/codebuild/output/src1852518591/src/pages/admins/supplier/[id]/mail/edit/[subId]/index.vue")
  }
]